var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":_vm.strokeWidth,"stroke-linecap":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M6 6l12 12M18 6L6 18"}})])}
var staticRenderFns = []

export { render, staticRenderFns }